import types from "cms/enums/contentsTypes.enum";
export var page = {
    label: "Résumé de page",
    type: types.PAGE
};
